import { Component } from '@verndale/core';
import { keyCode } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      container: this.el.querySelector('.brands-menu__inner'),
      trigger: this.el.querySelector('.dropdown-menu__dropdown-toggle'),
      dropdown: this.el.querySelector('.dropdown-menu__dropdown-list'),
      linksContainer: this.el.querySelector('.brands-menu__links'),
      links: [...this.el.querySelectorAll('.dropdown-menu__dropdown-list a')]
    };

    if (this.dom.links[2]) {
      this.dom.linksContainer.prepend(this.dom.links[2].cloneNode(true));
    }

    if (this.dom.links[1]) {
      this.dom.linksContainer.prepend(this.dom.links[1].cloneNode(true));
    }

    if (this.dom.links[0]) {
      this.dom.links[0].classList = 'btn btn--primary';
      this.dom.links[0].parentNode.remove();
      this.dom.container.prepend(this.dom.links[0]);
    }

    this.mobileBreakpoint = window.matchMedia('(max-width: 739px)');
    this.tabletBreakpoint = window.matchMedia('(max-width: 1279px)');
    this.focusedElement = 1;

    this.handleBreakpointReached();
    this.showDropdownButton();
  }

  addListeners() {
    this.tabletBreakpoint.addListener(this.handleBreakpointReached.bind(this));
    document.addEventListener('click', this.handleClickOutside.bind(this));
    this.dom.trigger.addEventListener('click', this.handleToggle.bind(this));
    this.dom.links.forEach(link =>
      link.addEventListener('keydown', this.handleKeyDown.bind(this))
    );
  }

  handleBreakpointReached() {
    if (this.tabletBreakpoint.matches) {
      this.dom.links.forEach(link => link.setAttribute('tabindex', -1));
    } else {
      this.dom.links.forEach(link => link.removeAttribute('tabindex'));
    }
  }

  showDropdownButton() {
    if (this.dom.links.length > 3) {
      this.dom.trigger.classList.add('enable');
    }
  }

  handleToggle(e) {
    e.stopPropagation();

    if (
      this.dom.dropdown.classList.contains('dropdown-menu__dropdown-list--open')
    ) {
      this.dom.dropdown.classList.remove('dropdown-menu__dropdown-list--open');
    } else {
      this.dom.dropdown.classList.add('dropdown-menu__dropdown-list--open');
      setTimeout(() => {
        this.focusedElement = this.mobileBreakpoint.matches ? 1 : 2;
        this.dom.links[this.focusedElement].focus();
      }, 200);
    }
  }

  handleClickOutside(e) {
    if (!this.dom.dropdown.contains(e.target)) {
      if (
        this.dom.dropdown.classList.contains(
          'dropdown-menu__dropdown-list--open'
        )
      ) {
        this.dom.dropdown.classList.remove(
          'dropdown-menu__dropdown-list--open'
        );
      }
    }
  }

  handleKeyDown(e) {
    const firstItem = this.mobileBreakpoint.matches ? 1 : 2;
    switch (e.keyCode) {
      case keyCode.HOME:
        e.preventDefault();
        this.focusedElement = firstItem;
        this.dom.links[this.focusedElement].focus();
        break;
      case keyCode.END:
        e.preventDefault();
        this.focusedElement = this.dom.links.length - 1;
        this.dom.links[this.focusedElement].focus();
        break;
      case keyCode.ESC:
        e.preventDefault();
        this.dom.dropdown.classList.remove(
          'dropdown-menu__dropdown-list--open'
        );
        this.dom.trigger.focus();
        break;
      case keyCode.TAB:
        this.dom.dropdown.classList.remove(
          'dropdown-menu__dropdown-list--open'
        );
        break;
      case keyCode.DOWN:
        e.preventDefault();
        this.focusedElement += 1;
        if (this.focusedElement >= this.dom.links.length) {
          this.focusedElement = firstItem;
        }
        this.dom.links[this.focusedElement].focus();
        break;
      case keyCode.UP:
        e.preventDefault();
        this.focusedElement -= 1;
        if (this.focusedElement === 0) {
          this.focusedElement = this.dom.links.length - 1;
        }
        this.dom.links[this.focusedElement].focus();
        break;

        break;
    }
  }
}

export default Module;
